import React from 'react';
import './sample.scss';

const SampleComparison = () => {
  return (
    <div className="sample-container" id="sample">
      <h3>Sample Comparison</h3>
      <img 
        src={require('../../../assets/sample places comparison - comapre places.png')}
        alt="sample comparison of places - compare places"
      />
    </div>
  )
}

export default SampleComparison;